module Meevo.Plugins.Register {

    export enum RegisterActionPromptResponseEnum {
        NoAction,
        NoSale,
        OnHold,
        Finalize
    }

    class RegisterActionPromptController {

        private hotKeysGroup: IShortCutGroup;

        static $inject = [
            "meevo.components.modal.ModalService",
            'meevo.components.short-cuts.ShortCutsService',
            "$mdDialog",
            "canHold",
            "canFinalize",
            "isFinalize",
            "messageText",
        ];

        constructor(
            private modalService: Meevo.Components.Modal.IModalService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            private $mdDialog,
            private canHold: boolean,
            private canFinalize: boolean,
            private isFinalize: boolean,
            public messageText: string) {
            if (this.messageText == undefined || this.messageText == null || this.messageText == "") {
                this.messageText = "MESSAGE_REGISTER_TRANSACTION_NOT_EMPTY";
            }

            this.hotKeysGroup = new ShortCutGroup([
                    {
                        shortCutName: 'REGISTER_PAY_NOW', callback: () => {
                            this.finalize()
                        }
                    },
                    {
                        shortCutName: 'REGISTER_NO_SALE', callback: () => {
                            this.noSale()
                        }
                    },
                    {
                        shortCutName: 'REGISTER_HOLD', callback: () => {
                            this.onHold()
                        }
                    },
                    {
                        shortCutName: 'REGISTER_CANCEL', callback: () => {
                            this.noAction()
                        }
                    },
                ],
                {
                    noun: Meevo.Model.NounEnum.Register,
                    deactivateGlobal: true,
                    groupLevel: Components.ShortCuts.GroupLevels.Modal
                }
            );
            this.shortCutsService.activateGroup(this.hotKeysGroup)
        }

        noAction() {
            return this.closeWithAction(RegisterActionPromptResponseEnum.NoAction);
        }

        noSale() {
            return this.closeWithAction(RegisterActionPromptResponseEnum.NoSale);
        }

        onHold() {
            if (this.canHold) {
                return this.closeWithAction(RegisterActionPromptResponseEnum.OnHold);
            } else {
                return this.noAction();
            }
        }

        finalize() {
            if (this.canFinalize) {
                return this.closeWithAction(RegisterActionPromptResponseEnum.Finalize);
            } else {
                return this.noAction();
            }
        }

        closeWithAction(action: RegisterActionPromptResponseEnum) {
            this.shortCutsService.deactivateGroup(this.hotKeysGroup)
            return this.$mdDialog.hide({
                action: action
            });
        }
        
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.RegisterActionPromptController", RegisterActionPromptController);
}